export const crearRedireccionUnica = (pendiente) => {
  let redireccionPendiente = Boolean(pendiente);

  return () => {
    if (!redireccionPendiente) return false;
    redireccionPendiente = false;
    return true;
  };
};
